export const agentRequests = {
  page: {
    filters: {
      accommodation: "Alojamiento",
      type: "Tipo",
    },
    subtitle: "Lo que te han pedido tus huéspedes a través del agente.",
    clearFilters: "Quitar filtros",
    loadMore: "Ver más",
    empty: "Todavía no hay solicitudes.",
    emptyFiltered: "No hay solicitudes con estos filtros.",
    columns: {
      type: "Tipo",
      guest: "Huésped",
      asks: "Qué pide",
      channel: "Canal",
      status: "Estado",
      when: "Cuándo",
      amount: "Importe",
    },
  },
  // La columna Importe: en qué quedó el cobro de cada solicitud.
  amount: {
    paid: "Pagado",
    awaiting: "Pendiente de pago",
    property: "A pagar en el alojamiento",
    void: "No cobrado",
    quote: "Ofrecido",
  },
  common: {
    title: "Solicitudes de Recepción IA",
  },
  widget: {
    iaBadge: "IA",
    subtitle: "Lo que han pedido tus huéspedes a través del agente.",
    todayOn: "Mostrando solo las de hoy",
    todayOff: "Mostrar solo las solicitudes de hoy",
    today: "Hoy",
    entersToday: "Entra hoy",
    entersTodayTitle: "Esta reserva entra hoy",
    test: "prueba",
    approve: "Aprobar",
    otherTime: "Otra hora",
    prioritize: "Priorizar",
    reject: "Rechazar",
    dismiss: "Descartar del panel",
    loading: "Cargando solicitudes…",
    empty: "Aún no hay solicitudes.",
    emptySub: "Cuando un huésped pida un late checkout, early check-in o más noches, aparecerá aquí.",
    viewAll: "Ver todas las solicitudes",
    entryTime: "Hora de entrada",
    cancel: "Cancelar",
    rejectIrreversible: "Esta acción no se puede deshacer.",
    modal: {
      approveTitle: "¿Aprobar la solicitud?",
      approveTimeTitle: "¿Aprobar a otra hora?",
      tentativeTitle: "¿Priorizar esta entrada?",
      rejectTitle: "¿Rechazar la solicitud?",
      defaultTitle: "¿Confirmar?",
      approveText: "Vas a aprobar la entrada anticipada de",
      approveTimeText: "Confirmarás la entrada a la hora que indiques para",
      tentativeText: "Le diremos que haréis todo lo posible por tenerlo listo a esa hora, aunque depende de la salida anterior y de la limpieza. Se le enviará a",
      rejectText: "Vas a rechazar la entrada anticipada de",
      defaultText: "Confirmar para",
      approveCta: "Sí, aprobar",
      approveTimeCta: "Confirmar hora",
      tentativeCta: "Sí, informar",
      rejectCta: "Sí, rechazar",
      defaultCta: "Confirmar",
    },
  },
  drawer: {
    close: "Cerrar",
    allAccommodations: "Todos los alojamientos",
    allTypes: "Todos los tipos",
    today: "Hoy",
    yesterday: "Ayer",
    from: "Desde",
    to: "Hasta",
    clear: "Limpiar",
    writeWhatsapp: "Escribir por WhatsApp",
    noMessages: "Sin mensajes guardados de este chat.",
    pause: "Pausar",
    play: "Reproducir",
    downloadMp3: "Descargar MP3",
    viewReservation: "Ver reserva",
    loading: "Cargando…",
    emptyFiltered: "No hay solicitudes con estos filtros.",
    end: "No hay más solicitudes.",
    features: {
      early: "Early check-in",
      late: "Late checkout",
      extend: "Alargar estancia",
      invoice: "Factura",
      handoff: "Acción requerida",
      callMessage: "Recados de llamada",
    },
    channels: {
      call: "Llamada",
    },
  },
  box: {
    rooms: "{count} habitación | {count} habitaciones",
    nights: "{count} noche | {count} noches",
    guests: "{count} huésped | {count} huéspedes",
    earlyRequestedTitle: "Early check-in solicitado",
    arrivalRequestedTitle: "Hora de llegada solicitada",
    early: "Early",
    arrives: "Llega",
  },
};
